/**
 * A PO line whose quantity was set to 0 (e.g. the warehouse can't supply it)
 * stays on the order and is shown struck through, so both sides can see what
 * was dropped instead of the line silently disappearing.
 */
export const isZeroQty = (qty: string | number | null | undefined): boolean =>
  qty !== '' && qty != null && Number(qty) === 0;

/** Row styling for a 0-qty line. */
export const ZERO_QTY_ROW_CLASS = 'text-muted-foreground line-through';
